import PointsBlock from './PointsBlock';

export default PointsBlock;
